import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';
import Scrollbar from '../../../components/scrollbar';
import CustomGridToolbar from '../../../components/custom-gridtoolbar';
import MastersService from '../../../services/masters.services'
import { handleError } from '../../../auth/utils'

// ---------------------------------------------------------------------------------------------------------------

ViewHistoryDataGrid.propTypes = {
    masterName: PropTypes.string,
    masterRowData: PropTypes.object,
};
// ---------------------------------------------------------------------------------------------------------

export default function ViewHistoryDataGrid({ masterName, masterRowData }) {
    // TODO: Integrate here history API
    const navigate = useNavigate();

    const [pageSize, setPageSize] = useState(5);


    // const { masterName } = useParams();
    const [columnData, setColumnData] = useState([]);
    const [rowHistoryData, setRowHistoryData] = useState([]);

    useEffect(() => {
        // Get the column names to show in the main grid 
        const masterRowColumns = MastersService.GetColumns(masterName);
        console.log('masterRowColumns', masterRowColumns)

        let historyRowColumns;
        const effectiveFromDateColumn = masterRowColumns.filter(column => column.field === 'effectiveFromDate');
        console.log('effectiveFromDateColumn', effectiveFromDateColumn)

        if (masterRowColumns && effectiveFromDateColumn.length > 0) {
            historyRowColumns = MastersService.GetColumns('importrowhistory2');
            console.log('historyRowColumns', historyRowColumns)
        } else {
            historyRowColumns = MastersService.GetColumns('importrowhistory');
            console.log('historyRowColumns', historyRowColumns)
        }

        const columns = [...historyRowColumns, ...masterRowColumns];
        setColumnData(columns);

        // Get the current master relcords 
        MastersService.GetRecordUpdateHistory(masterName, "", masterRowData.id)
            .then((response) => {
                if (response.status === 200) {
                    setRowHistoryData(response.data);
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error")
                }
            })
           .catch(_error => {
                    handleError(_error, navigate, "", "");
                });


    }, [masterName, masterRowData.id, navigate]);



    const CustomToolbar = useCallback(() =>
        <CustomGridToolbar
            rows={rowHistoryData}
            columnData={columnData}
            records={` Total No. of Records [${rowHistoryData.length}]`}
        />, [rowHistoryData, columnData]);

    return (
        <Scrollbar>
            <DataGrid
                rows={rowHistoryData}
                columns={columnData.filter(column => column.field !== 'id')}
                getRowId={(row) => rowHistoryData.indexOf(row)}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                disableSelectionOnClick
                components={{
                    Toolbar: CustomToolbar,
                }}
                //  rowHeight={30}
                //  headerHeight={35}
                density='compact'
            />
        </Scrollbar>
    );
}